import styled from 'styled-components';
import { DropdownMenu as SharedDropdownMenu } from '../dropdownStyles';

export const Base = styled.div`
	position: relative;
	width: 100%;
`;

export const Trigger = styled.button`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 12px;
	background: transparent;
	border: none;
	border-radius: 8px;
	text-align: left;
	transition: background 0.2s ease;
	min-width: 0;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
	}
`;

export const Info = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const Name = styled.span`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Plan = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Chevron = styled.div`
	flex-shrink: 0;
	display: flex;
	align-items: center;
`;

export const Menu = styled(SharedDropdownMenu)`
	bottom: calc(100% + 4px);
`;

export const AvatarWrap = styled.div`
	position: relative;
	flex-shrink: 0;
`;

export const MenuItemDot = styled.div`
	margin-left: auto;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.blue[600]};
`;
